import ServiceReports from '../../../../../services/ServiceReports';

class Service extends ServiceReports {
  constructor() {
    super('/callcenter/performance');
  }
}

export default new Service();
